import { Package } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';

const SIZES = { sm: 'size-10', lg: 'size-20' } as const;

/**
 * Foto de capa do produto, carregada direto da plataforma (ADR-035) — o troig não guarda a imagem.
 * `no-referrer`: a plataforma não fica sabendo qual tela do troig pediu a foto. Sem foto, ou se a
 * plataforma tirou a imagem do ar, fica o ícone no mesmo espaço, para a linha não pular.
 *
 * `alt` vazio de propósito: a foto sempre aparece ao lado do nome do produto, e repetir o nome
 * faria o leitor de tela ler duas vezes.
 */
export function ProductThumb({
  src,
  size = 'sm',
  className,
}: {
  src: string | null | undefined;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const frame = cn(
    'flex shrink-0 items-center justify-center overflow-hidden rounded-md border bg-card',
    SIZES[size],
    className,
  );
  if (!src || failed) {
    return (
      <span className={cn(frame, 'bg-muted text-muted-foreground')} aria-hidden>
        <Package className={size === 'lg' ? 'size-8' : 'size-4'} />
      </span>
    );
  }
  return (
    <span className={frame}>
      <img
        src={src}
        alt=""
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        className="size-full object-contain"
      />
    </span>
  );
}
